var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-contact-column caption"
  }, [_c('div', {
    staticClass: "column-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('footer.contact')))])]), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow-right-black-extended.svg"),
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/location-icon.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.google.com/maps/place/Churerstrasse+54,+8808+Pf%C3%A4ffikon,+Switzerland/@47.2012196,8.7782759,17z/data=!3m1!4b1!4m6!3m5!1s0x479ab14d5cbde19f:0x9fe764032bac78e7!8m2!3d47.2012196!4d8.7804646!16s%2Fg%2F11c5k_0qw3",
      "target": "_blank"
    }
  }, [_vm._v("Churerstrasse 54"), _c('br'), _vm._v(" CH-8808 Pfäffikon SZ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/phone-icon-black.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": "tel:+41 (0)58 521 19 00"
    }
  }, [_vm._v("+41 (0)58 521 19 00")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/world-icon.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": "http://www.seu.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.seu.ch")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-row"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/mail-icon.svg"),
      "alt": ""
    }
  })]), _c('a', {
    attrs: {
      "href": "mailto: info@seu.ch"
    }
  }, [_vm._v("info@seu.ch")])]);

}]

export { render, staticRenderFns }